import { extractDomain } from "./aiCompetitorsUrl";

const UUID_SESSION_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const toSessionSlug = (value = "") =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);

export const toDomainSessionId = (value = "") => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const domain = extractDomain(raw);
  if (domain) return toSessionSlug(domain);
  const host = raw
    .replace(/^https?:\/\//i, "")
    .split("/")[0]
    .split("?")[0]
    .replace(/^www\./i, "")
    .toLowerCase();
  return toSessionSlug(host);
};

export const toBrandSessionId = (brandName = "") => toSessionSlug(brandName);

export const isUuidSessionId = (sessionId) =>
  UUID_SESSION_PATTERN.test(String(sessionId || "").trim());

export const guessBrandSessionIdFromUrl = (websiteUrl = "") =>
  toDomainSessionId(websiteUrl);

export const readBrandQuery = (search = "") => {
  const params = new URLSearchParams(
    String(search || "").startsWith("?") ? search : `?${search}`
  );
  return String(params.get("brand") || "").trim();
};

export const isAiCompetitorsSessionFresh = (session, ttlMs) => {
  const updatedAt = Number(session?.updatedAt || session?.createdAt || 0);
  if (!updatedAt || !Number.isFinite(ttlMs)) return false;
  return Date.now() - updatedAt < ttlMs;
};
